import { useEffect, useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { classNames } from "../../helpers/classNames";
import { removeTag } from "../../helpers";

const Editor = ({
  type = "quill",
  value = "",
  onChange = () => {},
  label = "",
  id,
  placeholder,
  required,
  errorType,
  errorText,
  labelClasses,
}) => {
  const Quill = ReactQuill.Quill;
  // var Font = Quill.import("formats/font");
  // Font.whitelist = [
  //   "Roboto",
  //   "Raleway",
  //   "Montserrat",
  //   "Lato",
  //   "Rubik",
  //   "Inter",
  //   "Pacifico",
  // ];
  // Quill.register(Font, true);

  var Size = Quill.import("attributors/style/size");
  Size.whitelist = ["small", false, "large", "huge"];
  Quill.register(Size, true);

  const [textValue, setTextValue] = useState(value);

  useEffect(() => {
    if (value) {
      setTextValue(value);
    }
  }, [value, type]);

  const modules = {
    toolbar: [
      // [{ font: Font.whitelist }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
      // ["link", "image", "video"],
      ["link"],
      ["clean"],
    ],
  };

  return (
    <div className="relative space-y-1">
      {label && (
        <div
          className={classNames(
            "text-xs font-medium text-shades-07",
            labelClasses
          )}
        >
          {label}
          {required && (
            <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
              <i className="fa-solid fa-asterisk"></i>
            </span>
          )}
        </div>
      )}
      {type === "quill" && (
        <ReactQuill
          id={id}
          className="bg-white"
          theme="snow"
          value={textValue}
          onChange={(val) => {
            setTextValue(val);
            if (removeTag(val).trim() === "") {
              onChange("");
            } else {
              onChange(val);
            }
          }}
          placeholder={placeholder || "Write something awesome"}
          modules={modules}
        />
      )}
      {errorType && errorType === "danger" && (
        <div className="text-xs font-medium text-red-600">
          <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "warning" && (
        <div className="text-xs font-medium text-amber-500">
          <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "success" && (
        <div className="text-xs font-medium text-green-600">
          <i className="fa-regular fa-fw fa-circle-check text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "info" && (
        <div className="text-xs font-medium text-sky-600">
          <i className="fa-regular fa-fw fa-circle-info text-sm mr-1"></i>
          {errorText}
        </div>
      )}
    </div>
  );
};

export default Editor;
